import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	forecastManagement: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.forecast-management.forecast-management',
		defaultMessage: 'Forecast & management',
		description: 'Forecast & management links group title',
	},
	timeTrackingReport: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.forecast-management.time-tracking-report',
		defaultMessage: 'Time Tracking Report',
		description: 'Time tracking report in Classic Software project',
	},
	userWorkloadReport: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.forecast-management.user-workload-report',
		defaultMessage: 'User Workload Report',
		description: 'User workload report in Classic Software project',
	},
	versionWorkloadReport: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.forecast-management.version-workload-report',
		defaultMessage: 'Version Workload Report',
		description: 'Version workload report in Classic Software project',
	},
});
